export const H2_BASE_CSS_VARS = {
  "theme-website-h2-color-text": "var(--theme-website-color-text-primary)",
  "theme-website-h2-font-family": "InterVariable",
  "theme-website-h2-font-size": "3rem",
  "theme-website-h2-font-weight": "700",
  "theme-website-h2-line-height": "1.2",
  "theme-website-h2-letter-spacing": "0",
};
